import { render, staticRenderFns } from "./FactoryEarlyArtworkAccessForm.vue?vue&type=template&id=21d6f017&scoped=true&"
import script from "./FactoryEarlyArtworkAccessForm.vue?vue&type=script&lang=ts&"
export * from "./FactoryEarlyArtworkAccessForm.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryEarlyArtworkAccessForm.vue?vue&type=style&index=0&id=21d6f017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d6f017",
  null
  
)

export default component.exports